import type { OggiMessage } from "../oggi";

export const initialOggiMessages: OggiMessage[] = [
  {
    id: "welcome",
    role: "assistant",
    content:
      "Buongiorno, Denise. Oggi ci sono 3 opportunità che potrebbero interessare al Comune di Gallinaro.",
    createdAt: "2026-10-15T08:30:00.000Z",
  },
  {
    id: "opportunity",
    role: "assistant",
    content:
      "Ho trovato un bando regionale per la riqualificazione degli spazi pubblici. La scadenza è tra 18 giorni.",
    createdAt: "2026-10-15T08:30:05.000Z",
    opportunity: {
      title: "Riqualificazione degli spazi pubblici",
      organization: "Regione Lazio",
      deadline: "4 novembre 2026",
      budget: "Fino a 150.000 €",
    },
  },
];
